export default __webpack_public_path__ + "static/foto-5-7733c72b5cee2bf8844a0d4734f048bd.jpg";